$window = $(window);
const $root = $('body');
const $modalOverlay = $('.modal__overlay');

$(function() {
    // Header menu
    let menuSubItems = $('.header__sub-menu').find('li > a');
    let parentMenuSubItems = $('.header__sub-menu').find('li');
    let lastActiveMenu = $('.header__sub-menu').find('li.header__sub-menu-item--active');
    let lastId = lastActiveMenu.length > 0 ? lastActiveMenu[0].firstElementChild.id : lastActiveMenu = parentMenuSubItems[0].firstElementChild.id;

    const headerMenuSet = () => {
        if (lastId === parentMenuSubItems[0].firstElementChild.id) {
            parentMenuSubItems[0].classList.add('header__sub-menu-item--active');
            $('#' + parentMenuSubItems[0].firstElementChild.id + '-d').css('display','flex');
            lastActiveMenu = parentMenuSubItems;
        } else {
            $('#' + lastId + '-d').css('display','flex');
        }
    }

    const headerMenuOn = (item) => {
        $(parentMenuSubItems).each(function () {
            this.classList.remove('header__sub-menu-item--active');
            $('#' + lastId + '-d').css('display','none');
        });

        $('#' + item.id + '-d').css('display','flex');
    }

    const headerMenuOut = (item) => {
        $('#' + item.id + '-d').css('display','none');

        if (lastActiveMenu.length > 0) {
            lastActiveMenu[0].classList.add('header__sub-menu-item--active');
            $('#' + lastId + '-d').css('display','flex');
        }
    }

    $('#liising').on('click', function(e) {
        e.preventDefault();
        $(this, '.header__sub-nav').toggleClass('open');
        headerMenuSet();
    });

    $('#liising-mob').on('click', function(e) {
        e.preventDefault();
        $(this, '.header__sub-nav').toggleClass('open');
    });

    $('#liising').on('hover mouseover', function () {
        headerMenuSet();
    });

    $(menuSubItems).each(function () {
        $(this).on('hover mouseover', function () { headerMenuOn(this); });
        $(this).on('mouseout', function () { headerMenuOut(this); });
    });

    // Anchor handler
    // $('[data-link="anchor-link"]').on('click',function(e) {
    //     $root.animate({
    //         scrollTop: $root.scrollTop() + $($.attr(this, 'href')).offset().top
    //     }, 100);
    //
    //     return false;
    // });

    // Show more sliders
    const btnShowMore = document.getElementById("show-more-sliders");
    const moreSliders = document.getElementById("more-sliders");

    $(btnShowMore).on('click', () => {
        $(btnShowMore.parentElement).hide();
        $(moreSliders).removeClass('calculator__sliders--hidden');
    });

    // Range slider custom color
    const rangeInputs = document.querySelectorAll('input[type="range"]');

    function handleInputChange(e) {
        let target = e.target;

        if (e.target.type !== 'range') {
            target = document.getElementById('range');
        }

        const min = target.min;
        const max = target.max;
        const val = target.value;

        target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
    }

    rangeInputs.forEach(input => {
        input.addEventListener('input', handleInputChange);
    })

    // Sidebar toggle
    const btnBurger = document.getElementById('burger-btn');
    const sidebar = document.getElementById('sidebar');
    const sidebarOverlay = document.getElementById('sidebar-overlay');
    const burgerOpen = document.getElementById('burger-open');
    const burgerClose = document.getElementById('burger-close');

    const toggleBurger = () => {
        if ($(burgerOpen).hasClass('hidden')) {
            $(burgerOpen).removeClass('hidden');
            $(burgerClose).addClass('hidden');
        } else {
            $(burgerOpen).addClass('hidden');
            $(burgerClose).removeClass('hidden');
        }
    }

    $(btnBurger).on('click', () => {
        $(sidebar).toggleClass('sidebar--open');
        toggleBurger();
    });

    $(sidebarOverlay).on('click', () => {
        $(sidebar).removeClass('sidebar--open');
        toggleBurger();
    });

    // Sidebar sub menu toggle
    $('#liising-mob').on('click', function() {
        $('.sidebar__sub-menu').toggleClass('sidebar__sub-menu--open');
    })


    // Modal
    function openModal(modalId) {
        $modalOverlay.addClass('modal__overlay--show');
        $('#' + modalId).addClass('modal--open');
    }

    function closeModal(modalId) {
        $('#' + modalId).removeClass('modal--open');
        $modalOverlay.removeClass('modal__overlay--show');
    }

    $('.modal__close').on('click', (e) => {
        closeModal(e.target.parentElement.id);
    })

    $('#ask-btn').on('click', () => {
        openModal('ask-modal');
    });

    // Swiper
    const blogSwiperMain = new Swiper('.swiper-main', {
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
    const blogSwiperOne = new Swiper('.swiper-1', {
        spaceBetween: 30,

        pagination: {
            el: '.swiper-pagination1',
            clickable: true,
        },
    });
    const blogSwiperTwo = new Swiper('.swiper-2', {
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination2',
            clickable: true,
        },
    });
    const blogSwiperPost = new Swiper('.swiper-post', {
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination3',
            clickable: true,
        },
    });



    // Parallax scroll effect

    $('[data-type="background"]').each(function(){
        var $bgobj = $(this);

        $(window).scroll(function() {
            var yPos = -($window.scrollTop() / $bgobj.data('speed'));
            var coords = 'center ' + yPos + 'px';

            $bgobj.css({backgroundPosition: coords});
        });
    });


    // Tooltip
    let tooltip;
    const ttBtn = document.querySelectorAll('.tooltip__btn');

    function ttUpdate(btn, tooltip, ttArrow) {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
            placement: 'top',
            middleware: [
                window.FloatingUIDOM.offset(8),
                window.FloatingUIDOM.flip(),
                window.FloatingUIDOM.shift({ padding: 15 }),
                window.FloatingUIDOM.arrow({ element: ttArrow }),
            ]
        }).then(({ x, y, placement, middlewareData }) => {
            Object.assign(tooltip.style, {
                left: `${x}px`,
                top: `${y}px`,
            });

            const { x: arrowX, y: arrowY } = middlewareData.arrow;

            const staticSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
            }[placement.split('-')[0]];

            Object.assign(ttArrow.style, {
                left: arrowX != null ? `${arrowX}px` : '',
                top: arrowY != null ? `${arrowY}px` : '',
                right: '',
                bottom: '',
                [staticSide]: '-4px',
            });
        });
    }

    function ttShow() {
        tooltip = this.nextElementSibling;
        const ttArrow = tooltip.querySelector('.tooltip__arrow');

        tooltip.classList.add('show');

        ttUpdate(this, tooltip, ttArrow);
    }

    function ttHide() {
        tooltip.classList.remove('show');
    }

    [
        ['mouseenter', ttShow],
        ['mouseleave', ttHide],
        ['focus', ttShow],
        ['blur', ttHide],
    ].forEach(([event, listener]) => {
        ttBtn.forEach((item) => {
            item.addEventListener(event, listener);
        });
    });

});
